<template>
  <div
    class="h-100 rounded-lg border-2 border-transparent hover:border-brand transition-colors"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
